import { restClient } from '../../client';

export enum OperationalNoteResourceType {
  provider = 'provider',
  patient = 'patient',
  appointment = 'appointment',
}

export enum OperationalNoteType {
  adminProvider = 'admin_provider',
  adminPatient = 'admin_patient',
  adminAppointment = 'admin_appointment',
}

export type ProviderOperationalNote = {
  id: string;
  content: string;
  authorId: string;
  resourceType: OperationalNoteResourceType;
  resourceId: string;
  noteType: OperationalNoteType;
  archivedAt: string | null;
  createdAt: string;
};

export type CreateProviderNoteBody = {
  noteType: OperationalNoteType;
  content: string;
};

export const adminGetProviderOperationalNotes = (providerId: string) =>
  restClient.request<{ data: ProviderOperationalNote[] }>(`/api/v1/admin/providers/${providerId}/operational_notes`);

export const adminCreateProviderOperationalNote = (providerId: string, body: CreateProviderNoteBody) =>
  restClient.request<ProviderOperationalNote>(`/api/v1/admin/providers/${providerId}/operational_notes`, {
    method: 'POST',
    data: { note_type: body.noteType, content: body.content },
  });

export const adminArchiveProviderOperationalNote = (providerId: string, noteId: string) =>
  restClient.request(`/api/v1/admin/providers/${providerId}/operational_notes/${noteId}/archive`, {
    method: 'POST',
  });

export const adminUnarchiveProviderOperationalNote = (providerId: string, noteId: string) =>
  restClient.request(`/api/v1/admin/providers/${providerId}/operational_notes/${noteId}/unarchive`, {
    method: 'POST',
  });